import { Fragment, useRef } from "react";

import * as StateLib from "@/Utils/StateLib";
import { getHoverTipContent } from "@/Utils/Misc";
import { Menu, ToggleButton, ToggleButtonGroup, ToolIcon } from "@theorgchartdev/storybook";
import {
  kPhotoSizeOptions,
  kPhotoMaskOptions,
  enumUpdateProperty,
  enumChartElement
} from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { ConvertPhotoFrameSelection } from "@coreapp/utils/ConvertPhotoFrameSelection";

const BuildPhotoSizeOptions = clickHandler => {
  let photoSizingOptions = [];
  for (let size of kPhotoSizeOptions) {
    let sizeOption = {};
    sizeOption.value = size;
    sizeOption.label = size;
    sizeOption.clickHandler = clickHandler;
    photoSizingOptions.push(sizeOption);
  }
  return photoSizingOptions;
};

const BuildPhotoMaskOptions = UpdatePhotoMask => {
  let maskOptions = [];
  kPhotoMaskOptions.forEach(function (value, i) {
    let maskOption = {};
    maskOption.value = i;
    maskOption.label = appstr(value);
    maskOption.clickHandler = UpdatePhotoMask;
    maskOptions.push(maskOption);
  });
  return maskOptions;
};

const UpdateExpandToFill = selectedBoxProps => {
  StateLib.UpdateBoxProperty(
    enumUpdateProperty.cellExpandRow,
    selectedBoxProps.includes("expandtofill")
  );
};

const UpdatePhotoSize = target => {
  let newSize = ConvertPhotoFrameSelection(target.value);
  StateLib.UpdateBoxProperty(enumUpdateProperty.picFrame, newSize);
  const wsMgr = StateLib.GetWSMgr();
  const selectedCell = wsMgr.GetFirstSelectedElement(enumChartElement.boxCell);
  selectedCell?.SetupPictureCell();
  StateLib.ReRenderCanvas();
};

const UpdatePhotoMask = target => {
  StateLib.UpdateBoxProperty(enumUpdateProperty.picMask, parseInt(target.value));
};

export const PhotoCellToolsComposite = props => {
  const maskOpenCtrlRef = useRef(null);
  const sizeOpenCtrlRef = useRef(null);

  let wsMgr = StateLib.GetWSMgr();
  let currentBoxPropsToggled = [];
  let photoSizeValue;
  let photoMaskValue;
  let firstSelectedCell = null;
  let firstSelectedGutter = null;
  if (wsMgr) {
    firstSelectedCell = wsMgr.GetFirstSelectedElement(enumChartElement.boxCell);
    firstSelectedGutter = wsMgr.GetFirstSelectedElement(enumChartElement.gutterCell);

    let expandToFill = wsMgr.SurveySelection(enumUpdateProperty.cellExpandRow);
    if (expandToFill) currentBoxPropsToggled.push("expandtofill");
    photoSizeValue = wsMgr.SurveySelection(enumUpdateProperty.picFrame);
    if (photoSizeValue && photoSizeValue != -1)
      photoSizeValue = photoSizeValue.fX + " X " + photoSizeValue.fY;
    photoMaskValue = wsMgr.SurveySelection(enumUpdateProperty.picMask);
    if (photoMaskValue == null) photoMaskValue = 0;
  }

  let isPicture = false;
  let enableExpand = false;

  if (firstSelectedCell != null) {
    isPicture = firstSelectedCell.IsPicture();
    enableExpand = !isPicture;
  }

  let isGutterCell = firstSelectedGutter != null;

  let showPhotoControls = isPicture && !isGutterCell;
  let showExpandControl = enableExpand && !isGutterCell;

  const photoMaskTrigger = (
    <ToolIcon
      name={"hexagon-image"}
      tooltipProps={{ ...getHoverTipContent("imagemask"), referenceOpenCtrlRef: maskOpenCtrlRef }}
    />
  );
  const photoMaskOptions = BuildPhotoMaskOptions(UpdatePhotoMask);

  const photoSizeTrigger = (
    <ToolIcon
      name={"image-gear"}
      tooltipProps={{ ...getHoverTipContent("imagesize"), referenceOpenCtrlRef: sizeOpenCtrlRef }}
    />
  );
  const photoSizeOptions = BuildPhotoSizeOptions(UpdatePhotoSize);

  return (
    <Fragment>
      {showPhotoControls && (
        <Fragment>
          <Menu
            openCtrlRef={maskOpenCtrlRef}
            trigger={photoMaskTrigger}
            options={photoMaskOptions}
            value={photoMaskValue}
          />
          <Menu
            openCtrlRef={sizeOpenCtrlRef}
            trigger={photoSizeTrigger}
            options={photoSizeOptions}
            value={photoSizeValue}
          />
        </Fragment>
      )}
      {showExpandControl && (
        <ToggleButtonGroup onChange={UpdateExpandToFill} value={currentBoxPropsToggled}>
          <ToggleButton
            data-testid={`${props.dataTestIdPrefix}expand-to-fill`}
            icon={"arrows-from-dotted-line"}
            value={"expandtofill"}
            tooltipProps={getHoverTipContent("expandrow")}
          />
        </ToggleButtonGroup>
      )}
    </Fragment>
  );
};
